import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';
import type {
  ListMatrixCodeRevisionsParams,
  MatrixCodeRevisionsPage,
  QualityRecordMatrix,
} from '../model/matrix.types';

export async function listQualityRecordMatrices(): Promise<QualityRecordMatrix[]> {
  const response = await api.get<ApiResponse<QualityRecordMatrix[]>>('/matrices/quality-records');

  return response.data.data ?? [];
}

export async function listMatrixCodeRevisions(
  prefix: string,
  params: ListMatrixCodeRevisionsParams
): Promise<MatrixCodeRevisionsPage> {
  const response = await api.get<MatrixCodeRevisionsPage>(
    `/matrices/codes/${encodeURIComponent(prefix)}/revisions`,
    { params }
  );

  return response.data;
}
